// extracted by mini-css-extract-plugin
module.exports = {"slider":"SpringSlider_slider__3np9N","slides":"SpringSlider_slides__2Iplr","button":"SpringSlider_button__3kr6X"};